jQuery(function ($) {
  // Scroll Menu
  let headerHeight = $("header").height();
  let menuHeight = $("#wrap-header").height();
  let newMenuHeight = 0;
  $(window).scroll(function () {
    if ($(window).scrollTop() > $(window).height() / 2) {
      $("header").css("height", headerHeight);
      newMenuHeight = $("#wrap-header").height();

      $("#wrap-header").addClass("sticky");
    } else if ($(window).scrollTop() <= menuHeight - newMenuHeight) {
      $("header").css("height", "auto");
      $("#wrap-header").removeClass("sticky");
    }
  });

  // Bloquer le scroll si le menu est ouvert
  $("#mobile-nav").change(function () {
    if (this.checked) {
      $("header").css("height", headerHeight);
      newMenuHeight = $("#wrap-header").height();
      $("#wrap-header").addClass("sticky");
      $("html, body").css({
        overflow: "hidden",
        height: "100%",
      });
    } else {
      $("html, body").css({
        overflow: "auto",
        height: "auto",
      });
    }
  });

  // Mobile
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  ) {
    $("#menu-menu-principal a").click(function () {
      $(".menu-icon").click();
    });
  }
});
